import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { RotatingLines } from "react-loader-spinner";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteIcon } from "../../assets/Icons/icons";
import { Decrypt, Encrypt, imageOnError } from "../../common/utils/Functions";
import { IMAGE_BASE_URL } from "../../constants/constants";
import useFetch from "../../customHook/useFetch";
import styles from "../../scss/common/common.module.scss";
import BundleItemModal from "../../common/sections/bundleItemModal";
import BundleCheckoutInfoSummary from "../../common/sections/BundleCheckoutInfoSummary";
import ModalLayout from "../../common/layouts/ModleLayout";
import AppButton from "../../common/theme/Button";
import type { CartDisplayAttachedSingle } from "../../common/utils/cartLineHelpers";
import {
  getBundleLineSubtotal,
  shouldCountAttachedSinglePrices,
  shouldCountBundleProductPrices,
} from "../../common/utils/cartLineHelpers";
import CartItemChangeNote from "../../common/sections/CartItemChangeNote";
import type { CartLineChange } from "../../common/utils/cartStoreChanges";

const ProductCartShoppingCard = ({
  cartIndex,
  cartItem: cartProductItem,
  reLoadCart,
  setReLoadCart,
  setIsContinueDisable,
  itemIndex,
  editOptionValue,
  includedInBundleText,
  attachedDisplaySingles,
  bundleDisplayLabel = "",
  storeChange,
  onAcceptChanges,
  onRemoveChangedItem,
}: {
  cartIndex: number;
  cartItem: any;
  reLoadCart: boolean;
  setReLoadCart: (value: boolean) => void;
  setIsContinueDisable: any;
  itemIndex: number;
  editOptionValue?: (productId: number, optionId: number, type: any) => void;
  /** e.g. "Included in Bundle #1" for singles attached to a bundle */
  includedInBundleText?: string;
  /** From buildCartDisplayEntries: attached rows (same refs as cart array). */
  attachedDisplaySingles?: CartDisplayAttachedSingle[];
  /** e.g. "Bundle #1" for bundle rows */
  bundleDisplayLabel?: string;
  storeChange?: CartLineChange | null;
  onAcceptChanges?: () => void;
  onRemoveChangedItem?: () => void;
}) => {
  console.log(cartProductItem, "cartProductItem", cartIndex);

  const [cartItemIndex, setCartItemIndex] = useState(0);
  const [productOptions, setProductOptions] = useState<any[]>([]);
  // const navigate = useNavigate();
  const storeData = useSelector((state: any) => state.storeDataSlice.data);
  const [open, setOpen] = React.useState(false);
  const [cartItem, setCartItem] = useState<any>();

  useEffect(() => {
    setCartItem(cartProductItem);
  }, [cartProductItem]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setReLoadCart(!reLoadCart);
    setOpen(false);
  };

  const [loadSingleProductsQuery, { loading: singleProductLoading }] = useFetch(
    `/get-products-info/public/${cartItem?.id}`,
    {
      method: "get",
    }
  );
  const [loadBundleQuery, { loading: bundleProductLoading }] = useFetch(
    `/bundle/info/${cartItem?.id}`,
    {
      method: "get",
    }
  );

  const callSingleProduct = async () => {
    const response = await loadSingleProductsQuery();
    if (response?.data?.status) {
      setCartItem({
        ...cartItem,
        minimum_quantity: response?.data?.data?.minimum_quantity,
        maximum_quantity: response?.data?.data?.maximum_quantity,
      });
    }
  };
  const callBundleProduct = async () => {
    const response = await loadBundleQuery();
    if (response?.data?.status) {
      setCartItem({
        ...cartItem,
        bundle_products: cartItem?.bundle_products?.map((item: any) => ({
          ...item,
          store_product_detail: {
            ...item?.store_product_detail,
            minimum_quantity: response?.data?.data?.bundle_products?.filter(
              (filterItem: any) => filterItem?.id === item?.id
            )?.[0]?.store_product_detail?.minimum_quantity,
            maximum_quantity: response?.data?.data?.bundle_products?.filter(
              (filterItem: any) => filterItem?.id === item?.id
            )?.[0]?.store_product_detail?.maximum_quantity,
          },
        })),
      });
    }
  };

  const [num, setNum] = useState<any>();
  const [qtyError, setQtyError] = useState("");
  useEffect(() => {
    if (qtyError === "") {
      setIsContinueDisable(false);
    } else {
      setIsContinueDisable(true);
    }
  }, [qtyError]);

  const [productCartQty, setProductCartQty] = useState(0);

  let handleChange = (e: any) => {
    if (e.target.value === "") {
      setNum("");
      setQtyError(
        "Minimum Quantity allowed is " + (cartItem?.minimum_quantity || "1")
      );
    } else if (e.target.value < 1) {
      setQtyError(
        "Minimum Quantity allowed is " + (cartItem?.minimum_quantity || "1")
      );
    } else {
      let minUpdate = false;
      let maxUpdate = false;
      if (cartItem?.isSingleProduct) {
        if (cartItem?.minimum_quantity && cartItem?.minimum_quantity !== null) {
          if (e.target.value >= cartItem?.minimum_quantity) {
            minUpdate = true;
          } else {
            minUpdate = false;
            setQtyError(
              "Minimum Quantity allowed is " +
                (cartItem?.minimum_quantity || "1")
            );
          }
        } else {
          if (e.target.value > 0) {
            minUpdate = true;
          } else {
            minUpdate = false;
            setQtyError("Minimum Quantity allowed is 1");
          }
        }
        if (cartItem?.maximum_quantity && cartItem?.maximum_quantity !== null) {
          if (
            Number(e.target.value) + Number(productCartQty) <=
            cartItem?.maximum_quantity
          ) {
            maxUpdate = true;
          } else {
            maxUpdate = false;
            setQtyError(
              "Maximum Quantity allowed is " +
                (cartItem?.maximum_quantity || "1")
            );
          }
        } else {
          if (e.target.value > 0) {
            maxUpdate = true;
          }
          // if()
        }
      }

      if (minUpdate && maxUpdate) {
        setQtyError("");

        let newCartData = [];
        const cartDataInfoD = localStorage?.getItem("cart");
        const cartDataInfo = Decrypt(cartDataInfoD);
        const cartOldData = cartDataInfo ? JSON.parse(cartDataInfo) : [];

        if (cartOldData && cartOldData.length > 0) {
          newCartData = cartOldData;
          // const cartItemIndex = newCartData.findIndex(
          //   (cartProduct: any) => cartProduct.id === cartItem?.id
          // );
          newCartData[itemIndex] = {
            ...cartItem,
            quantity: parseInt(e.target.value),
          };
        }
        // newCartData.push(newCartData)
        const cartData = JSON.stringify(newCartData);
        const cartDataEn = Encrypt(cartData);
        localStorage.setItem("cart", cartDataEn);
        setCartItem({
          ...cartItem,
          quantity: parseInt(e.target.value),
        });
      }
      if (parseInt(e.target.value) <= 1000) {
        setNum(parseInt(e.target.value));
      }
    }
    setReLoadCart(!reLoadCart);
  };

  const [cartImages, setCartImages] = useState([]);
  const [totalProductPrice, setTotalProductPrice] = useState(0);
  const [totalBundleProducts, setTotalBundleProducts] = useState(0);
  const [attachedSingles, setAttachedSingles] = useState<CartDisplayAttachedSingle[]>([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [cartData, setCartData] = useState(false);
  const openDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };
  const hasMultiImages = cartImages.length > 1;

  const removeItem = () => {
    setDeleteLoading(true);
    // let newCartData = [];
    const cartDataInfoD = localStorage?.getItem("cart");
    const cartDataInfo = Decrypt(cartDataInfoD);
    const cartOldData = cartDataInfo ? JSON.parse(cartDataInfo) : [];

    if (cartOldData && cartOldData.length > 0) {
      const row = cartOldData[itemIndex];
      const removedLineId = row?.cartLineId;
      const isBundleRow = row && !row.isSingleProduct;
      cartOldData.splice(itemIndex, 1);
      if (isBundleRow && removedLineId != null) {
        for (let i = cartOldData.length - 1; i >= 0; i--) {
          const r = cartOldData[i];
          if (
            r?.isSingleProduct &&
            Number(r.parentBundleLineId) === Number(removedLineId)
          ) {
            cartOldData.splice(i, 1);
          }
        }
      }
    }
    const cartData: any = JSON.stringify(cartOldData);
    setCartData(true);
    // setCartImages(cartData?.store_product_images[0]?.image);
    const cartDataEn = Encrypt(cartData);
    localStorage.setItem("cart", cartDataEn);
    setReLoadCart(!reLoadCart);
    setDeleteLoading(false);
    setDeleteModal(false);
    toast.success("Removed successfully");
  };

  const handleToggleEditMode = (
    productId: number,
    optionId: number,
    type: boolean
  ) => {
    const productOptionsCopy = [...productOptions];
    const currentOptionIndex = productOptionsCopy.findIndex(
      (item: any) => item.id === optionId && item.productId === productId
    );
    if (currentOptionIndex !== -1) {
      productOptionsCopy[currentOptionIndex].isEditing = type;
    } else {
      productOptionsCopy.push({
        id: optionId,
        productId: productId,
        isEditing: type,
      });
    }
    setProductOptions(productOptionsCopy);
    if (!type) {
      let newCartData: any = [];
      const cartDataInfoD = localStorage?.getItem("cart");
      const cartDataInfo = Decrypt(cartDataInfoD);
      const cartOldData = cartDataInfo ? JSON.parse(cartDataInfo) : [];

      if (cartOldData && cartOldData.length > 0) {
        newCartData = cartOldData;
        console.log(cartItem, "cartItem", cartIndex, newCartData[cartIndex]);
        // const cartItemIndex = newCartData.findIndex(
        //   (cartProduct: any) => cartProduct.id === cartItem?.id
        // );
        newCartData[cartIndex] = cartItem;
      }

      // newCartData.push(newCartData)
      const cartData = JSON.stringify(newCartData);
      const cartDataEn = Encrypt(cartData);
      localStorage.setItem("cart", cartDataEn);
    }
  };
  const handleUpdateCart = (
    productId: number,
    optionId: number,
    selectedValue: any
  ) => {
    let cartItemCopy: any = { ...cartItem };
    const store_options = cartItemCopy?.store_options;
    const currentOptionIndex = store_options.findIndex(
      (item: any) => item.id === optionId
    );
    if (currentOptionIndex !== -1) {
      store_options[currentOptionIndex].selectedData = selectedValue;
    }
    cartItemCopy.store_options = store_options;
    setCartItem(cartItemCopy);
  };
  useEffect(() => {
    const images: any = [];

    if (cartItem) {
      if (!cartItem?.isSingleProduct) {
        cartItem?.bundle_products.map((product: any) => {
          if (product.store_product_detail.store_product_images.length > 0) {
            images.push({
              img: product.store_product_detail.store_product_images[0].image,
            });
          } else {
            images.push({ img: "/images/default-product.png", noImg: true });
          }
        });
      } else {
        if (cartItem?.store_product_images.length > 0) {
          images.push({ img: cartItem?.store_product_images[0].image });
        } else {
          images.push({ img: "/images/default-product.png", noImg: true });
        }
      }
    }
    setCartImages(images);
    setCartData(false);
    setNum(cartItem?.isSingleProduct ? cartItem?.quantity : 1);
  }, [cartData, cartItem]);

  useEffect(() => {
    if (cartItem) {
      let totalBundleProduct = 0;
      const cartDataInfoD = localStorage?.getItem("cart");
      const cartDataInfo = Decrypt(cartDataInfoD);
      const cartAllData = cartDataInfo ? JSON.parse(cartDataInfo) : [];
      const payType = storeData?.payment_handle_type;
      if (!cartItem?.isSingleProduct) {
        cartItem?.bundle_products?.forEach((product: any) => {
          totalBundleProduct += Number(product.store_product_detail.quantity);
        });
        const fromDisplay =
          attachedDisplaySingles ??
          cartAllData
            .map((row: any, idx: number) => ({ index: idx, item: row }))
            .filter(
              ({ item }: { item: any }) =>
                item?.isSingleProduct &&
                item?.parentBundleLineId != null &&
                Number(item.parentBundleLineId) === Number(cartItem?.cartLineId)
            );
        fromDisplay.forEach(({ item }: CartDisplayAttachedSingle) => {
          totalBundleProduct += item?.quantity ? Number(item.quantity) : 0;
        });
        setAttachedSingles(fromDisplay);
        setTotalProductPrice(
          shouldCountBundleProductPrices(payType) ||
            shouldCountAttachedSinglePrices(payType)
            ? getBundleLineSubtotal(cartAllData, cartItem, payType)
            : 0
        );
        setTotalBundleProducts(totalBundleProduct);
      } else {
        const totalQty = cartAllData
          .filter(
            (item: any) =>
              item.id === cartItem?.id &&
              item.isSingleProduct &&
              Number(item.parentBundleLineId || 0) ===
                Number(cartItem?.parentBundleLineId || 0)
          )
          .reduce((sum: number, item: any) => {
            if (item.cartItemId === cartItem?.cartItemId) return sum;
            return sum + Number(item.quantity || 0);
          }, 0);
        setProductCartQty(totalQty);
        setAttachedSingles([]);
        const quantity =
          cartItem?.quantity !== undefined ? cartItem?.quantity : 1;
        setTotalProductPrice(Number(cartItem?.club_price || 0) * quantity);
      }
    }
  }, [cartItem, reLoadCart, attachedDisplaySingles, storeData?.payment_handle_type]);

  return (
    <div className={styles.shoppingCart_main}>
      <Box style={{ width: "100%", display: "flex" }}>
        <div className={styles.shoppingCart_img}>
          {cartImages.length ? (
            cartImages.map((img: any, index: number) =>
              index < 4 ? (
                <div
                  key={index}
                  className={`${styles.img_wrap} ${
                    hasMultiImages ? styles.multiImage : ""
                  }`}
                >
                  {index === 3 && cartImages.length > 4 ? (
                    <div className={styles.layer}>+{cartImages.length - 4}</div>
                  ) : (
                    ""
                  )}

                  <img
                    loading="lazy"
                    onError={(event) => imageOnError(event)}
                    src={img.noImg ? img.img : IMAGE_BASE_URL + img.img}
                    alt=""
                  />
                </div>
              ) : (
                ""
              )
            )
          ) : (
            <>
              <div className={styles.img_wrap}>
                <img
                  loading="lazy"
                  onError={(event) => imageOnError(event)}
                  src="/images/default-product.png"
                  alt=""
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.shoppingChat_heading}>
          {!cartItem?.isSingleProduct ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <span>{bundleDisplayLabel}</span>
                <p
                  className={styles.viewBundle}
                  // onClick={() => navigate(`/bundle-detail/${cartItem?.id}`)}
                  onClick={() => {
                    callBundleProduct();
                    handleOpen();
                    setCartItemIndex(cartIndex);
                  }}
                >
                  <span>View Bundle</span>
                </p>
                <BundleCheckoutInfoSummary
                  cartIndex={cartIndex}
                  bundleCheckoutInfo={cartItem?.bundle_checkout_info}
                  reLoadCart={reLoadCart}
                  setReLoadCart={setReLoadCart}
                />
              </div>
              <div>
                <span>
                  {storeData.is_price_hide !== 1 &&
                  storeData.payment_handle_type !== 2 ? (
                    <span>{`$${parseFloat(totalProductPrice.toString()).toFixed(2)}`}</span>
                  ) : (
                    <span>{`$0.00`}</span>
                  )}
                </span>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                {includedInBundleText ? (
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#444",
                      margin: "0 0 6px",
                      fontWeight: 600,
                    }}
                  >
                    {includedInBundleText}
                  </p>
                ) : null}
                <span>{cartItem?.product_name}</span>
                {/* <p
                  className={styles.viewBundle}
                  // onClick={() => navigate(`/bundle-detail/${cartItem?.id}`)}
                  onClick={() => {
                    callSingleProduct();
                    handleOpen();
                  }}
                >
                  <span>View Detail</span>
                </p> */}
                {cartItem?.isSingleProduct &&
                  cartItem?.store_options &&
                  cartItem?.store_options.length > 0 &&
                  cartItem?.store_options.map((option: any, index: number) => {
                    const item = option.store_option_items.filter(
                      (optionItem: any) => optionItem.id === option.selectedData
                    );
                    const currentOption = productOptions.find(
                      (item: any) =>
                        item.id === option.id && item.productId === cartItem.id
                    );
                    return (
                      <p
                        className={styles.productPTag}
                        key={index}
                        style={{
                          lineHeight: "18px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {option.display_name}:{" "}
                        {option.option_type === 1 ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {currentOption?.isEditing ? (
                              <>
                                <select
                                  defaultValue={option.selectedData}
                                  onChange={(e) => {
                                    editOptionValue &&
                                      editOptionValue(
                                        cartItem.id,
                                        option.id,
                                        Number(e.target.value)
                                      );
                                    handleUpdateCart(
                                      cartItem.id,
                                      option.id,
                                      Number(e.target.value)
                                    );
                                    // Update options state here
                                  }}
                                >
                                  {option.store_option_items.map(
                                    (item: any) => (
                                      <option key={item.id} value={item.id}>
                                        {item.option_name}
                                      </option>
                                    )
                                  )}
                                </select>
                                <button
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "1px solid #0F1729",
                                    cursor: "pointer",
                                    height: "20px",
                                    width: "20px",
                                    borderRadius: "4px",
                                  }}
                                  onClick={() => {
                                    handleToggleEditMode(
                                      cartItem.id,
                                      option.id,
                                      false
                                    );
                                  }}
                                >
                                  <svg
                                    width="18px"
                                    height="18px"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M19.7071 6.29289C20.0976 6.68342 20.0976 7.31658 19.7071 7.70711L10.4142 17C9.63316 17.7811 8.36683 17.781 7.58579 17L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929C3.68342 10.9024 4.31658 10.9024 4.70711 11.2929L9 15.5858L18.2929 6.29289C18.6834 5.90237 19.3166 5.90237 19.7071 6.29289Z"
                                      fill="#0F1729"
                                    />
                                  </svg>
                                </button>
                              </>
                            ) : (
                              <>
                                {item.length > 0
                                  ? item[0].option_name
                                  : option.selectedData}
                                <button
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    height: "20px",
                                    width: "20px",
                                    borderRadius: "4px",
                                  }}
                                  onClick={() => {
                                    handleToggleEditMode(
                                      cartItem.id,
                                      option.id,
                                      true
                                    );
                                    // Update options state here
                                  }}
                                >
                                  <svg
                                    width="20px"
                                    height="20px"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z"
                                      stroke="#000000"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13"
                                      stroke="#000000"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </button>
                              </>
                            )}
                          </div>
                        ) : item.length > 0 ? (
                          item[0].option_name
                        ) : (
                          option.selectedData
                        )}
                      </p>
                    );
                    // if (option.option_type === 1 || option.option_type === 2) {
                    // }
                  })}
              </div>
              <span>
                {storeData.is_price_hide !== 1 &&
                storeData.payment_handle_type !== 2 ? (
                  cartItem &&
                  `${
                    cartItem?.club_price === null
                      ? `$${(0).toFixed(2)}`
                      : `$${(cartItem?.club_price * cartItem?.quantity).toFixed(
                          2
                        )}`
                  }`
                ) : (
                  <span>{`$0.00`}</span>
                )}
              </span>
            </div>
          )}
          {storeChange ? (
            <CartItemChangeNote
              changes={storeChange.changes || []}
              unavailable={storeChange.unavailable}
              onAccept={onAcceptChanges}
              onRemove={onRemoveChangedItem || removeItem}
            />
          ) : null}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
            }}
            className={styles.shoppingCart_container}
          >
            {!storeChange ? (
              <button onClick={openDeleteModal}>Remove</button>
            ) : (
              <span />
            )}
            <div className={styles.shoppingChat_items}>
              {!cartItem?.isSingleProduct && (
                <button className={styles.qtyBtn}>
                  Qty : 1 bundle ({totalBundleProducts} items)
                </button>
              )}

              {cartItem?.isSingleProduct && (
                <>
                  <div
                    className={`${styles.custom_incrementDecrement} ${styles.incDecInputWrap}`}
                  >
                    <div className={`${styles.input_group} `}>
                      <div className={styles.incDecWrap}>
                        <button
                          disabled={num <= (cartItem?.minimum_quantity || 1)}
                          className={styles.btn}
                          type="button"
                          onClick={() =>
                            handleChange({ target: { value: num - 1 } })
                          }
                        >
                          -
                        </button>
                      </div>
                      <input
                        type="number"
                        className={styles.form_control}
                        value={num}
                        onChange={handleChange}
                      />
                      <div className={styles.incDecWrap}>
                        <button
                          disabled={num >= (cartItem?.maximum_quantity || 1000)}
                          className={styles.btn_outline}
                          type="button"
                          onClick={() =>
                            handleChange({ target: { value: num + 1 } })
                          }
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                  <p className={styles.errorMsg}>{qtyError}</p>
                </>
              )}

              <BundleItemModal
                cart={cartItem}
                cartIndex={cartItemIndex}
                title=""
                subtitle=""
                size=""
                price=""
                handleOpen={handleOpen}
                handleClose={handleClose}
                open={open}
                productLoading={singleProductLoading || bundleProductLoading}
                attachedSingles={attachedSingles}
                bundleDisplayLabel={bundleDisplayLabel}
              />
            </div>

            <ModalLayout
              modalWidth={470}
              open={deleteModal}
              headingCenter
              handleClose={openDeleteModal}
              handleOpen={openDeleteModal}
              title="Remove Item"
              icon={deleteIcon}
              subtitle={
                <p>
                  Are you sure you want to remove{" "}
                  {!cartItem?.isSingleProduct
                    ? bundleDisplayLabel
                    : `${cartItem?.product_name}`}{" "}
                  from the cart?
                </p>
              }
            >
              <div
                style={{
                  marginTop: "2.5rem",
                  display: "flex",
                  justifyContent: " center",
                  gap: "1.25rem",
                }}
              >
                <AppButton onClick={openDeleteModal}>No</AppButton>
                <AppButton
                  type="submit"
                  disabled={deleteLoading}
                  onClick={removeItem}
                >
                  {deleteLoading && (
                    <span className="loadingBars">
                      <RotatingLines
                        strokeColor="currentColor"
                        strokeWidth="5"
                        animationDuration="0.75"
                        width="20"
                      />
                    </span>
                  )}
                  Yes, Remove
                </AppButton>
              </div>
            </ModalLayout>
          </div>
        </div>
      </Box>

      {/*  for showing buttons in mobile view outside the images and price */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
          width: "100%",
          alignItems: "center",
        }}
        className={styles.shoppingCart_mob_view}
      >
        {!storeChange ? (
          <button onClick={openDeleteModal}>Remove</button>
        ) : (
          <span />
        )}
        <div className={styles.shoppingChat_items}>
          {!cartItem?.isSingleProduct && (
            <button className={styles.qtyBtn}>
              Qty : 1 bundle ({totalBundleProducts} items)
            </button>
          )}

          {cartItem?.isSingleProduct && (
            <>
              <div
                className={`${styles.custom_incrementDecrement} ${styles.incDecInputWrap}`}
              >
                <div className={`${styles.input_group} `}>
                  <div className={styles.incDecWrap}>
                    <button
                      disabled={num <= (cartItem?.minimum_quantity || 1)}
                      className={styles.btn}
                      type="button"
                      onClick={() =>
                        handleChange({ target: { value: num - 1 } })
                      }
                    >
                      -
                    </button>
                  </div>
                  <input
                    type="number"
                    className={styles.form_control}
                    value={num}
                    onChange={handleChange}
                  />
                  <div className={styles.incDecWrap}>
                    <button
                      disabled={num >= (cartItem?.maximum_quantity || 1000)}
                      className={styles.btn_outline}
                      type="button"
                      onClick={() =>
                        handleChange({ target: { value: num + 1 } })
                      }
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
              <p className={styles.errorMsg}>{qtyError}</p>
            </>
          )}

          <BundleItemModal
            cart={cartItem}
            cartIndex={cartItemIndex}
            title=""
            subtitle=""
            size=""
            price=""
            handleOpen={handleOpen}
            handleClose={handleClose}
            open={open}
            productLoading={singleProductLoading || bundleProductLoading}
            attachedSingles={attachedSingles}
            bundleDisplayLabel={bundleDisplayLabel}
          />
        </div>

        <ModalLayout
          modalWidth={470}
          open={deleteModal}
          headingCenter
          handleClose={openDeleteModal}
          handleOpen={openDeleteModal}
          title="Remove Item"
          icon={deleteIcon}
          subtitle={
            <p>
              Are you sure you want to remove{" "}
              {!cartItem?.isSingleProduct
                ? bundleDisplayLabel
                : `${cartItem?.product_name}`}{" "}
              from the cart?
            </p>
          }
        >
          <div
            style={{
              marginTop: "2.5rem",
              display: "flex",
              justifyContent: " center",
              gap: "1.25rem",
            }}
          >
            <AppButton onClick={openDeleteModal}>No</AppButton>
            <AppButton
              type="submit"
              disabled={deleteLoading}
              onClick={removeItem}
            >
              {deleteLoading && (
                <span className="loadingBars">
                  <RotatingLines
                    strokeColor="currentColor"
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="20"
                  />
                </span>
              )}
              Yes, Remove
            </AppButton>
          </div>
        </ModalLayout>
      </div>
    </div>
  );
};

export default ProductCartShoppingCard;
